<template>
  <div id="input_delivery">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="topForm.pageList"
    />
    <div class="container">
      <section>
        <div class="title">
          <h1>事前現場調査入力画面</h1>
        </div>
        <div class="input_list">
          <ul>
            <li>
              <input type="checkbox" :id="'pri'" :checked="isAllPri" @click="allPriSelect()"/>
              <label :for="'pri'">{{label.pri}}</label>
            </li>
            <li>
              <ul class="indent_ul">
                <li v-for="pri in inPri" :key="pri.id">
                  <input type="checkbox" :id="'pri_' + pri.id" v-model="checked.priValues" :value="pri" :change="select()"/>
                  <label :for="'pri_' + pri.id">{{pri.name}}</label>
                </li>
                <li>
                  <div>{{label.checkOthers}}</div>
                  <textarea class="list_box" cols="80" rows="5" maxlength="256" v-model="form.resrchPriConfComment"></textarea>
                </li>
              </ul>
            </li>
            <li>
              <input type="checkbox" :id="'pub'" :checked="isAllPub" @click="allPubSelect()"/>
              <label :for="'pub'">{{label.pub}}</label>
            </li>
            <li>
              <ul class="indent_ul">
                <li v-for="pub in inPub" :key="pub.id">
                  <input type="checkbox" :id="'pub_' + pub.id" v-model="checked.pubValues" :value="pub" :change="select()"/>
                  <label :for="'pub_' + pub.id">{{pub.name}}</label>
                </li>
                <li>
                  <div>{{label.checkOthers}}</div>
                  <textarea cols="80" rows="5" maxlength="256" v-model="form.resrchPubConfComment"></textarea>
                </li>
              </ul>
            </li>
            <li>
              <div class="list_key">その他コメント</div>
              <textarea class="list_box" cols="80" rows="8" maxlength="256" v-model="form.resrchOtherComment"></textarea>
            </li>
            <li>
              事前調査希望日（火・日曜日は休業日のため不可）
            </li>
            <li>
              <ul>
                <li>
                  <span>
                    <label>{{label.resrchPref1}}</label>
                    <label class="important small_text">{{label.message}}</label>
                  </span>
                  <span class="list_day">
                    <template>
                      <dd-calendar
                        :schedule="schedule"
                        :value="this.form.resrchPref1"
                        @selectedDate="selectedDate1"
                      />
                    </template>
                    <div class="time">
                      <ul>
                        <li>
                          <input type="radio" id="resrchPref1" name="resrchPref1Type" :value="0" v-model="form.resrchPref1Type">
                          <label for="resrchPref1" class="radio-label bold">指定なし</label>
                        </li>
                        <li>
                          <input type="radio" id="resrchPref1_time1" name="resrchPref1Type" :value="1" v-model="form.resrchPref1Type" :disabled="disablePref1Type==1">
                          <label for="resrchPref1_time1" class="radio-label bold">AM( 9:00 ～ 13:00)</label>
                        </li>
                        <li>
                          <input type="radio" id="resrchPref1_time2" name="resrchPref1Type" :value="2" v-model="form.resrchPref1Type" :disabled="disablePref1Type==2">
                          <label for="resrchPref1_time2" class="radio-label bold">PM(13:00 ～ 17:00)</label>
                        </li>
                      </ul>
                    </div>
                  </span>
                  <div v-if="errors.resrchPref1" class="error_text">{{errors.resrchPref1}}</div>
                </li>
                <li>
                  <div>
                    <span>{{label.resrchPref2}}</span>
                    <span class="important small_text">{{label.message}}</span>
                  </div>
                  <div class="list_day">
                    <template>
                      <dd-calendar
                        :schedule="schedule"
                        :value="this.form.resrchPref2"
                        @selectedDate="selectedDate2"
                      />
                    </template>
                    <div class="time">
                      <ul>
                        <li>
                          <input type="radio" id="resrchPref2" name="resrchPref2Type" :value="0" v-model="form.resrchPref2Type">
                          <label for="resrchPref2" class="radio-label bold">指定なし</label>
                        </li>
                        <li>
                          <input type="radio" name="resrchPref2Type" :value="1" v-model="form.resrchPref2Type" :disabled="disablePref2Type==1">
                          <label for="resrchPref2_time1" class="radio-label bold">AM( 9:00 ～ 13:00)</label>
                        </li>
                        <li>
                          <input type="radio" name="resrchPref2Type" :value="2" v-model="form.resrchPref2Type" :disabled="disablePref2Type==2">
                          <label for="resrchPref2_time2" class="radio-label bold">PM(13:00 ～ 17:00)</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-if="errors.resrchPref2" class="error_text">{{errors.resrchPref2}}</div>
                </li>
                <li>
                  <div>上記以外にて日程調整を希望の場合</div>
                  <textarea class="list_box" cols="80" rows="5" maxlength="256" placeholder="例：水曜か木曜の午前希望" v-model="form.resrchScheduleComment"></textarea>
                </li>
              </ul>
            </li>
            <li>
              <ul>
                <li>
                  <span>
                    <label>{{label.observer}}</label>
                    <label class="important small_text">{{label.message}}</label>
                  </span>
                  <div>
                    <input type="radio" id="observer_1" name="observer" :value="1" v-model="form.resrchObserver">
                    <label for="observer_1" class="radio-label bold">あり</label>
                    <input type="radio" id="observer_2" name="observer" :value="0" v-model="form.resrchObserver">
                    <label for="observer_2" class="radio-label bold">なし</label>
                  </div>
                </li>
              </ul>
              <ul>
                <li>
                  <div>調査先への入室方法</div>
                  <textarea class="list_box" cols="80" rows="5" maxlength="256" placeholder="例：管理人に声をかけて、鍵を借りてください" v-model="form.resrchEntranceComment"></textarea>
                </li>
              </ul>
            </li>
            <!-- 事前調査全体 -->
          </ul>
        </div>
        <div class="control_btn_area">
          <div class="detail_btn2" @click="prev()">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
          <div class="detail_btn" @click="confirm()">注文確認画面へ</div>
        </div>
        <div class="researh_caution">※まだ正式注文ではございません</div>
      </section>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'BuildingResearchInput',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'buildingResearchInput',
      topForm: {},
      errors: {},
      label: {
        pri: '専有部分',
        priPosition: '設置場所の採寸',
        priGround: '設置場所の下地確認',
        priPlug: 'コンセント・PS等壁設置物確認',
        priCeiling: '照明・自火報等天井設置物確認',
        priCarryRoute: '搬入経路の有効寸法確認',
        pub: '共有部分',
        pubTruckPark: 'トラック停車位置',
        pubCarryRoute: '搬入経路',
        pubElevator: 'エレベーターサイズ',
        pubRequest: '搬入施工時の事前申請',
        pubCuring: '共有部養生の有無',
        pubParking: '駐車場の有無',
        checkOthers: 'その他確認事項',
        message: '必須',
        resrchPref1: '第一候補日',
        resrchPref2: '第二候補日',
        observer: '事前現場調査依頼者の当日立ち合い'
      },
      // 専有部分選択情報
      inPri: [
        {id: 1, name: '設置場所の採寸', flag: false},
        {id: 2, name: '設置場所の下地確認', flag: false},
        {id: 3, name: 'コンセント・PS等壁設置物確認', flag: false},
        {id: 4, name: '照明・自火報等天井設置物確認', flag: false},
        {id: 5, name: '搬入経路の有効寸法確認', flag: false}
      ],
      // 共有部分選択情報
      inPub: [
        {id: 1, name: 'トラック停車位置', flag: false},
        {id: 2, name: '搬入経路', flag: false},
        {id: 3, name: 'エレベーターサイズ', flag: false},
        {id: 4, name: '搬入施工時の事前申請', flag: false},
        {id: 5, name: '共有部養生の有無', flag: false},
        {id: 6, name: '駐車場の有無', flag: false}
      ],
      // チェックされた値を格納
      checked: {
        priValues: [],
        pubValues: []
      },
      form: {
        resrchPriPositionFlg: false,
        resrchPriGroundFlg: false,
        resrchPriPlugFlg: false,
        resrchPriCeilingFlg: false,
        resrchPriCarryRouteFlg: false,
        resrchPriConfComment: '',
        resrchPubTruckParkFlg: false,
        resrchPubCarryRouteFlg: false,
        resrchPubElevatorFlg: false,
        resrchPubRequestFlg: false,
        resrchPubCuringFlg: false,
        resrchPubParkingFlg: false,
        resrchPubConfComment: '',
        // 画像添付一旦廃止
        // resrchAttchImgComment: '',
        // imgName: '選択されていません',
        resrchOtherComment: '',
        resrchPref1: '',
        resrchPref1Type: 0,
        resrchPref2: '',
        resrchPref2Type: 0,
        resrchScheduleComment: '',
        resrchObserver: 1,
        resrchEntranceComment: ''
      },
      isAllPri: false,
      isAllPub: false,
      minOrderDate: '',
      firstDate: { // IE用の日付
        year: '',
        month: '',
        day: ''
      },
      secondDate: { // IE用の日付
        year: '',
        month: '',
        day: ''
      },
      // カレンダーの設定
      schedule: {},
      disablePref1Type: -1,
      disablePref2Type: -1
    }
  },
  methods: {
    prev: function () {
      this.$router.go(-1)
    },
    scheduling: function () {
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      let payload = {
        params: {
          categoryId: this.topForm.categoryId
        }
      }
      axios.get(DC_URL.SCHEDULE + '/resrch', payload)
        .then(response => {
          this.schedule = response.data.data
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    allPriSelect: function () {
      // 専有部分にチェックが入った状態で押されたか
      if (this.isAllPri) {
        this.checked.priValues = []
        this.isAllPri = false
      } else {
        this.checked.priValues = []
        for (let secret in this.inPri) {
          this.checked.priValues.push(this.inPri[secret])
        }
        this.isAllPri = true
      }
    },
    allPubSelect: function () {
      // 共有部分にチェックが入った状態で押されたか
      if (this.isAllPub) {
        this.checked.pubValues = []
        this.isAllPub = false
      } else {
        this.checked.pubValues = []
        for (let official in this.inPub) {
          this.checked.pubValues.push(this.inPub[official])
        }
        this.isAllPub = true
      }
    },
    select: function () {
      // 子項目をチェックしたとき
      this.isAllPri = (this.checked.priValues.length === this.inPri.length)
      this.isAllPub = (this.checked.pubValues.length === this.inPub.length)
    },
    // 画像添付一旦廃止
    // onFileChange (e) {
    //   const files = e.target.files || e.dataTransfer.files
    //   this.form.imgName = files[0].name
    // },
    confirm: function () {
      this.errors = {}
      this.validateDate()
      this.validateFormat()
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      App.setLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED, this.checked)
      this.flgConvert()
      // 画像添付一旦廃止
      // if (this.form.imgName === '選択されていません') this.form.imgName = ''
      App.setLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH, this.form)
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.RESEARCH + '/input', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.$router.push('/research/confirm')
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    flgConvert: function () {
      for (let i = 0; i < this.checked.priValues.length; i++) {
        // 一致したときに対応するフラグをtrueに変換する
        switch (this.checked.priValues[i].id) {
          case 1: this.form.resrchPriPositionFlg = true
            break
          case 2: this.form.resrchPriGroundFlg = true
            break
          case 3: this.form.resrchPriPlugFlg = true
            break
          case 4: this.form.resrchPriCeilingFlg = true
            break
          case 5: this.form.resrchPriCarryRouteFlg = true
            break
        }
      }
      for (let m = 0; m < this.checked.pubValues.length; m++) {
        switch (this.checked.pubValues[m].id) {
          case 1: this.form.resrchPubTruckParkFlg = true
            break
          case 2: this.form.resrchPubCarryRouteFlg = true
            break
          case 3: this.form.resrchPubElevatorFlg = true
            break
          case 4: this.form.resrchPubRequestFlg = true
            break
          case 5: this.form.resrchPubCuringFlg = true
            break
          case 6: this.form.resrchPubParkingFlg = true
            break
        }
      }
    },
    selectedDate1: function (selectedDate) {
      this.form.resrchPref1Type = 0
      this.form.resrchPref1 = moment(selectedDate).format('YYYY-MM-DD')
      this.disablePref1Type = this.checkResrvDate(this.form.resrchPref1)
    },
    selectedDate2: function (selectedDate) {
      this.form.resrchPref2Type = 0
      this.form.resrchPref2 = moment(selectedDate).format('YYYY-MM-DD')
      this.disablePref2Type = this.checkResrvDate(this.form.resrchPref2)
    },
    checkResrvDate: function (date) {
      let resrvDate = this.schedule.resrvDates.find(d => moment(d.date).isSame(date, 'day'))
      if (resrvDate) return resrvDate.timeType
      return -1
    },
    fetchData: function () {
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      let lresearchForm = App.getLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
      let lcheckedValues = App.getLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
      if (Object.keys(lresearchForm).length > 0) {
        this.form = Object.assign({}, lresearchForm)
        // 専有・共有のフラグをすべて初期化
        this.$set(this.form, 'resrchPriPositionFlg', false)
        this.$set(this.form, 'resrchPriGroundFlg', false)
        this.$set(this.form, 'resrchPriPlugFlg', false)
        this.$set(this.form, 'resrchPriCeilingFlg', false)
        this.$set(this.form, 'resrchPriCarryRouteFlg', false)
        this.$set(this.form, 'resrchPubTruckParkFlg', false)
        this.$set(this.form, 'resrchPubCarryRouteFlg', false)
        this.$set(this.form, 'resrchPubElevatorFlg', false)
        this.$set(this.form, 'resrchPubRequestFlg', false)
        this.$set(this.form, 'resrchPubCuringFlg', false)
        this.$set(this.form, 'resrchPubParkingFlg', false)
      }
      // チェックされていた値を保持させる
      if (Object.keys(lcheckedValues).length > 0) {
        this.checked = Object.assign({}, lcheckedValues)
      }
    },
    validateRequire: function () {
      // 必須チェック
      if (!this.form.resrchPref1) this.errors['resrchPref1'] = this.label.resrchPref1 + 'は必須項目です。'
      if (!this.form.resrchPref2) this.errors['resrchPref2'] = this.label.resrchPref2 + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isDate(this.form.resrchPref1)) {
        this.errors['resrchPref1'] = this.label.resrchPref1 + 'の日付の形式が間違っています。'
      }
      if (!Check.isDate(this.form.resrchPref2)) {
        this.errors['resrchPref2'] = this.label.resrchPref2 + 'の日付の形式が間違っています。'
      }
    },
    validateDate: function () {
      if (this.form.resrchPref1 === this.form.resrchPref2) {
        this.errors['resrchPref1'] = this.label.resrchPref1 + 'は他の希望日と別日に設定してください'
        this.errors['resrchPref2'] = this.label.resrchPref2 + 'は他の希望日と別日に設定してください'
      }
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.scheduling()
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style>
.indent_remark {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcBuildingResearchInput.vue